// A single source for the keys used for storing items in localStorage.

const LOCAL_STORAGE_KEYS = {
  LOGIN_AUTH_TOKEN: 've-atkn',
  LOGIN_USER: 've-login-user',
  LOGIN_USER_ID: 've-login-user-id',
}

export default LOCAL_STORAGE_KEYS
